//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    selectList: {
      type: Array,
      default: () => []
    },
    selectTitle: {
      type: String
    },
    selectValue: {
      type: String
    },
    selectIndex: {
      type: String
    },
    clickElementClientY: {
      type: Number
    },
    itemStyle: {
      type: String
    }

  },
  data () {
    return {
      dialogCurrentTop: 300
    }
  },
  mounted () {
    let self = this
    self.$nextTick(() => {
      console.log(self.$refs.dialogRuleBox.clientHeight)
      console.log(self.clickElementClientY, 'clickElementClientY')
      let contentHeight = self.$refs.dialogRuleBox.clientHeight
      console.log(contentHeight, 'contentHeight')
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      console.log(scrollTop, 'scrollTop')
      console.log(window.screen.height, 'window.screen.height')
      if (self.clickElementClientY + contentHeight - scrollTop > window.screen.height - 80) {
        self.dialogCurrentTop = window.screen.height - contentHeight - 80
      } else {
        self.dialogCurrentTop = self.clickElementClientY - scrollTop
      }
    })
  },
  methods: {
    /** 关闭登陆弹窗 */
    dialogClose (event) {
      event.stopPropagation()
      event.preventDefault()
      this.$emit('getSelecDialogState', false)
    },
    changeValue (e, item) {
      e.stopPropagation()
      e.preventDefault()
      this.$emit('setSelectValue', item)
      this.$emit('getSelecDialogState', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/formulaComponent/selectDialog.vue